export default __webpack_public_path__ + "static/media/online-pn-all-button.22c6ba4a.svg";